import React from "react";
import { Typography, Row, Col, Image } from "antd";
import "./AboutTema.css";
const { Title, Paragraph } = Typography;

const AboutTema = () => {
  return (
    <div>
      <Title level={1}>About TEMA</Title>
      <Image
        src="/images/art_catalysts-web.jpg"
        alt="about TEMA hero"
        preview={false}
      />
      <Paragraph className="common-paragraph">
        Technology Marketing (TEMA) is the hydroprocessing and refinery
        technology commercialization center of excellence for Chevron
        Corporation. TEMA has about 120 employees in areas of hydroprocessing
        research and development, process and mechanical design, catalyst
        manufacture, project execution, technical service, technology sales and
        marketing, and joint venture operations.
      </Paragraph>

      <Title level={2}>Experience</Title>
      <Paragraph className="common-paragraph">
        Chevron pioneered the modern technique of high-pressure hydrocracking –
        using hydrogen and catalysts to make more high-value products from
        heavy, residual fuels left over after conventional refining skims off
        the lightest elements of the crude. During the last five decades,
        Chevron's Technology Marketing group has invested millions of dollars
        annually developing technologies and catalysts that enable refiners to
        easily and economically respond to changing requirements in the market.
        Today we are the leading developer of hydroprocessing technologies
        around the world – technologies that are available through Chevron
        Lummus Global LLC (CLG) and Advanced Refining Technologies LP (ART).
        Chevron licenses its proprietary technologies in more than 40 percent
        of the world's refineries in dozens of countries, including China,
        Russia, India and the United States. Technology Marketing is a part of
        Chevron's Downstream & Chemicals Business Unit which, in addition to
        TEMA, comprises 18 wholly-owned or affiliated refineries in 13
        countries.
      </Paragraph>

      <Title level={2}>Expanding the boundaries of technology</Title>
      <Paragraph className="common-paragraph">
        As the refining industry continues pushing to meet the challenges of
        producing more and higher quality transportation fuels and lubes from
        increasingly difficult feeds, Chevron Technology Marketing continues
        showing them how. A strong hydroprocessing heritage sets the stage for
        competitive advantage in new generations of clean-fuel technologies.
        TEMA is developing technologies for producing clean products from
        alternative materials – ranging from Canadian tar sands bitumen; shale
        oil; and heavy, high acid crudes to clean burning natural gas. To
        optimize hydrocarbon technology, Technology Marketing actively seeks
        new research and development collaborations that will strengthen
        proprietary capabilities and advance its global technology base.
      </Paragraph>

      <Title level={2}>Sharing our expertise</Title>
      <Paragraph className="common-paragraph">
        Committed to technology development, Chevron has formed joint ventures
        with industry leaders Lummus Technology and W. R. Grace & Co. for
        marketing its technology and catalysts. Please visit the websites for
        our joint ventures.
      </Paragraph>
      <div className="art_catalysts-diagram">
        <Image 
          src="/images/art_catalysts-diagram-New.jpg"
          alt="Chevron, GRACE, McDermott diagram"
          preview={false}
        />
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
          <div className="icon-column">
            <Title level={4}>ART catalysts</Title>
            <Paragraph>
              <a
                href="https://www.arthydroprocessing.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                ART is a leading supplier<br /> of hydroprocessing<br /> catalysts
              </a>
            </Paragraph>
          </div>
          </Col>
          <Col xs={24} sm={12}>
          <div className="icon-column-last">
            <Title level={4}>CLG technology</Title>
            <Paragraph>
              <a
                href="https://www.chevronlummus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                The leading licensor of hydroprocessing<br /> and other
                associated bottom-of-the-barrel<br /> upgrading technologies
              </a>
            </Paragraph>
          </div>
          </Col>
        </Row>
      </div>
  );
};

export default AboutTema;